import styled from "styled-components";
import { isMobileOnly } from "react-device-detect";

export const StyledArrowWrapper = styled.div`
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: ${isMobileOnly ? "12vw" : "2vw"};

    cursor: pointer;
    z-index: 1;

    transition: background-color 200ms;
    background-color: transparent;

    :hover {
        background-color: black;
        background-color: rgba(0, 0, 0, 0.2);
        svg {
            display: initial;
        }
    }

    @media (max-width: 576px) {
        display: none;
    }
`;
